import { Box, Circle, TouchableBox, useCircleSize } from "arkh";
import React from "react";
import { View } from "react-native";

export function TodoListItemContainer(props: {
  isNew?: boolean;
  isFirst?: boolean;
  isLast?: boolean;
  onPress: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  disableInsideBorder?: boolean;
}) {
  return (
    <View>
      {props.isNew ? (
        <View
          style={{
            position: "absolute",
            justifyContent: "center",
            height: "100%",
            left: -12,
            zIndex: 20,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Circle size="dot" color="washedText" />
        </View>
      ) : null}
      <TouchableBox
        color="surface"
        spaceHorizontal="medium"
        style={{
          overflow: "hidden",
          borderRightWidth: 1,
          borderLeftWidth: 1,
          borderBottomWidth: props.isLast ? 1 : 0,
          borderTopWidth: props.isFirst ? 1 : 0,
          marginHorizontal: props.disableInsideBorder ? 0 : -1,
          marginBottom: props.isLast ? -1 : 0,
          marginTop: props.isFirst ? -1 : 0,
        }}
        cornerRadiusBottomLeft={props.isLast ? "large" : "none"}
        cornerRadiusBottomRight={props.isLast ? "large" : "none"}
        cornerRadiusTopRight={props.isFirst ? "large" : "none"}
        cornerRadiusTopLeft={props.isFirst ? "large" : "none"}
        borderColor="border-primary"
        onPress={props.onPress}
        disabled={props.disabled}
      >
        {props.children}
      </TouchableBox>
    </View>
  );
}

export function TodoListItemContainerContent(props: {
  children: React.ReactNode;
}) {
  const smallMedium = useCircleSize("smallMedium");
  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
        height: smallMedium,
      }}
    >
      {props.children}
    </Box>
  );
}
